const wxShareToolObject = {
    isShowAppIcon: false,
    isWxLaunchReady: false,
    isAndroid: function () {
        if (typeof window === 'undefined') return false;
        return navigator.userAgent.toLocaleLowerCase().match(/android/);
    },
    events: {},
    on: function (eventName, fn) {
        if (typeof window === 'undefined') return false;
        this.events[eventName] = this.events[eventName] || [];
        this.events[eventName].push(fn);
    },
    off: function (eventName, fn) {
        if (typeof window === 'undefined') return false;
        if (this.events[eventName]) {
            for (var i = 0; i < this.events[eventName].length; i++) {
                if (this.events[eventName][i] === fn) {
                    this.events[eventName].splice(i, 1);
                    break;
                }
            }
        }
    },
    emit: function (eventName, data) {
        if (typeof window === 'undefined') return false;
        if (this.events[eventName]) {
            this.events[eventName].forEach(function (fn) {
                fn.apply(null, data);
            });
        }
    },
};

let wxShareTool = wxShareToolObject;

if (typeof window !== 'undefined') {
    window.wxShareTool = window.wxShareTool ? window.wxShareTool : wxShareToolObject;

    wxShareTool = window.wxShareTool;
}

export { wxShareTool };
